import { render } from "./mmiColombia.vue?vue&type=template&id=11034ff7&scoped=true&ts=true"
import script from "./mmiColombia.vue?vue&type=script&lang=ts"
export * from "./mmiColombia.vue?vue&type=script&lang=ts"

import "./mmiColombia.vue?vue&type=style&index=0&id=11034ff7&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11034ff7"]])

export default __exports__